// extracted by mini-css-extract-plugin
export default {"CloseIcon":"Modal_CloseIcon__dgzfv","ModalContainer":"Modal_ModalContainer__bRVCn","ModalBackgroundScreen":"Modal_ModalBackgroundScreen__avRYh"};